import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { serchSelect, tabulation } from "@/mixins/index";
import { getSqlRecordList } from "@/api/dataAll/dataAll";
export default {
  name: "SQLrecords",
  mixins: [serchSelect, tabulation],
  data: function data() {
    return {
      searchData: {
        page: 1,
        page_size: 10
      },
      tableData: []
    };
  },
  created: function created() {},
  computed: {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;
      getSqlRecordList(this.searchData).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data || [];
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    }
  }
};